import { useContext, useEffect, useState } from "react";
import "../../../routes/Admin/admin.styles.scss";
import FormModal from "../../../components/customForm/formModal.component";
import Layout from "../../../components/Layout";
import AdminGeneralTable from "../AdminGeneralTable";
import {
  useGetCountriesOptionsQuery,
  useGetDestinationOptionsQuery,
  useGetDestinationsQuery,
} from "../../../apiCaller/apis/getApi";
import AdminSectionTitle from "../AdminSectionTitle";
import { DestinationAdminTableColumns } from "../../../utils/columns";
import {
  CountriesOptionMapper,
  DestinationMapper,
} from "../../../utils/DataMapper";
import { useDeleteDestinationMutation } from "../../../apiCaller/apis/deleteApi";
import { toast } from "react-toastify";
import {
  AddDestinationImageSchema,
  AddDestinationImageUiShema,
  AddDestinationSchema,
  AddDestinationUiSchema,
} from "../../../utils/forms";
import { GetTableListAPI } from "../../../apiCaller/getAPIsCaller";
import {
  useAddDestinationImageMutation,
  useAddDestinationMutation,
} from "../../../apiCaller/apis/postApi";
import { useUpdateDestinationMutation } from "../../../apiCaller/apis/updateApi";

const AdminDestinations = () => {
  const {
    data: countries,
    error,
    isLoading,
    isFetching,
  } = GetTableListAPI({}, useGetCountriesOptionsQuery);
  const {
    data: destinationOptions,
    error: destinationOptionsError,
    isLoading: destinationOptionsIsLoading,
    isFetching: destinationOptionsIsFetching,
  } = GetTableListAPI({}, useGetDestinationOptionsQuery);

  const [
    deleteDestination,
    {
      data: response,
      isLoading: deleteLoading,
      isError: postIsError,
      error: postError,
      isSuccess,
    },
  ] = useDeleteDestinationMutation({});
  const [
    addDestination,
    {
      data: addDestinationResponse,
      isLoading: addDestinationLoading,
      isError: addDestinationIsError,
      error: addDestinationError,
      isSuccess: addDestinationIsSuccess,
    },
  ] = useAddDestinationMutation({});

  const [
    updateDestination,
    {
      data: updateDestinationResponse,
      isLoading: updateDestinationLoading,
      isError: updateDestinationIsError,
      error: updateDestinationError,
      isSuccess: updateDestinationIsSuccess,
    },
  ] = useUpdateDestinationMutation({});
  const [
    addDestinationImage,
    {
      data: addDestinationImagenResponse,
      isLoading: uaddDestinationImageLoading,
      isError: uaddDestinationImageIsError,
      error: uaddDestinationImageError,
      isSuccess: uaddDestinationImageIsSuccess,
    },
  ] = useAddDestinationImageMutation({});

  const [countriesLookup, setCountriesLookup] = useState([]);

  const handleDelete = async (id, close) => {
    const result = await deleteDestination(id);
    if (result) {
      if (result.data.IsSuccess) {
        toast("Destination deleted successful");
      } else {
        toast("Action was unsuccessful");
      }
      close();
    }
  };

  const handleAddDestination = async (data, close) => {
    const result = await addDestination(data);
    if (result) {
      console.log(result?.data?.IsSuccess);
      if (
        result?.data?.IsSuccess !== undefined &&
        result?.data?.IsSuccess !== false
      ) {
        toast("Destination Added successful");
        close();
      } else {
        toast("An error occured");
      }
    }
  };

  const handleUpdate = async (data, close) => {
    console.log(data);
    const result = await updateDestination({
      destinationId: data.id,
      data: data,
    });
    if (result) {
      console.log(result?.data?.IsSuccess);
      if (
        result?.data?.IsSuccess !== undefined &&
        result?.data?.IsSuccess !== false
      ) {
        toast("Destination Updated successful");
        close();
      } else {
        toast("An error occured");
      }
    }
  };

  const handleImageUpload = async (data, close) => {
    console.log("In index upload", data);
    const result = await addDestinationImage(data);
    if (result) {
      console.log(result?.data?.IsSuccess);
      if (
        result?.data?.IsSuccess !== undefined &&
        result?.data?.IsSuccess !== false
      ) {
        toast("Destination Image Added successful");
        close();
      } else {
        toast("An error occured");
      }
    }
  };

  useEffect(() => {
    if (CountriesOptionMapper !== undefined && countries !== undefined) {
      setCountriesLookup(CountriesOptionMapper(countries));
    }
  }, [countries]);
  return (
    <Layout>
      <div className="mx-10">
        <div className="admin__header">{/* <Navigation/> */}</div>
        <main>
          <div>
            <AdminSectionTitle
              title={"Destination"}
              subTitle={"A list of destinations"}
              schema={AddDestinationSchema}
              uischema={AddDestinationUiSchema(
                countriesLookup,
                destinationOptions
              )}
              addButtonTitle={"Destination"}
              addFormTitle={"Add Destination"}
              addFormSubtitle={"Adding Destination"}
              handleSubmit={handleAddDestination}
            />
          </div>

          <div className="admin__content-table">
            <AdminGeneralTable
              caller={useGetDestinationsQuery}
              tableInfo={{
                actionButtons: ["view"],
                toRoute: "/schedules",
                actionBtns: ["add-schedules"],
                hasMore: false,
                noActions: true,
                columns: DestinationAdminTableColumns,
              }}
              deleteFunc={handleDelete}
              mapper={DestinationMapper}
              deleteLoading={deleteLoading}
              updateSchema={AddDestinationSchema}
              updateUiSchema={AddDestinationUiSchema(
                countriesLookup,
                destinationOptions
              )}
              handleImageUpload={handleImageUpload}
              imageSchema={AddDestinationImageSchema}
              imageUiSchema={AddDestinationImageUiShema()}
              updateSubmitFunc={handleUpdate}
              route={"Destination"}
              allowImageManagement
              title={"Destination"}
              subtitle={"Destination"}
            />
          </div>
        </main>
        <FormModal />
      </div>
    </Layout>
  );
};

export default AdminDestinations;
